jQuery.noConflict();

var $document = jQuery(document);

$document.ready(function($) {
    setTimeout(function(){
        $('.menu-toggle').on('click', function(){
            $(this).next().toggleClass('active');
        });
    },1000)
});